import { render } from "./QuickPublish.vue?vue&type=template&id=ac0cfc58&scoped=true"
import script from "./QuickPublish.vue?vue&type=script&lang=js"
export * from "./QuickPublish.vue?vue&type=script&lang=js"

import "./QuickPublish.vue?vue&type=style&index=0&id=ac0cfc58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0cfc58"]])

export default __exports__